import { render, staticRenderFns } from "./senDetail.vue?vue&type=template&id=11fca441&scoped=true&"
import script from "./senDetail.vue?vue&type=script&lang=js&"
export * from "./senDetail.vue?vue&type=script&lang=js&"
import style0 from "./senDetail.vue?vue&type=style&index=0&id=11fca441&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fca441",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11fca441')) {
      api.createRecord('11fca441', component.options)
    } else {
      api.reload('11fca441', component.options)
    }
    module.hot.accept("./senDetail.vue?vue&type=template&id=11fca441&scoped=true&", function () {
      api.rerender('11fca441', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chat/components/senDetail.vue"
export default component.exports